import { render, staticRenderFns } from "./badges.page.vue?vue&type=template&id=1c57f970&scoped=true&"
import script from "./badges.page.vue?vue&type=script&lang=js&"
export * from "./badges.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c57f970",
  null
  
)

export default component.exports